'use strict';

module.exports = ['$stateProvider', function ($stateProvider) {
    /** Configuro gli endpoint **/

    $stateProvider
        .state('uaa-module-profile-detail', {
            url: '/profile',
            template: require('../components/profile/profileDetail/profileDetail.html'),
            controller: 'ngDroUaaProfileDetailCtrl',
            parent: 'main'
        })

        .state('uaa-module-person-list', {
            url: '/person',
            template: require('../components/person/personList/personList.html'),
            controller: 'ngDroUaaPersonListCtrl',
            parent: 'main'
        })
        .state('uaa-module-person-add', {
            url: '/person/add',
            template: require('../components/person/personDetail/personDetail.html'),
            controller: 'ngDroUaaPersonDetailCtrl',
            parent: 'main'
        })
        .state('uaa-module-person-edit', {
            url: '/person/:id/edit',
            template: require('../components/person/personDetail/personDetail.html'),
            controller: 'ngDroUaaPersonDetailCtrl',
            parent: 'main'
        })


        .state('uaa-module-role-list', {
            url: '/role',
            template: require('../components/role/roleList/roleList.html'),
            controller: 'ngDroUaaRoleListCtrl',
            parent: 'main'
        })
        .state('uaa-module-role-add', {
            url: '/role/add',
            template: require('../components/role/roleDetail/roleDetail.html'),
            controller: 'ngDroUaaRoleDetailCtrl',
            parent: 'main'
        })
        .state('uaa-module-role-edit', {
            url: '/role/:id/edit',
            template: require('../components/role/roleDetail/roleDetail.html'),
            controller: 'ngDroUaaRoleDetailCtrl',
            parent: 'main'
        })

        .state('uaa-module-group-list', {
            url: '/group',
            template: require('../components/group/groupList/groupList.html'),
            controller: 'ngDroUaaGroupListCtrl',
            parent: 'main'
        })

        .state('uaa-module-company-list', {
            url: '/company',
            template: require('../components/company/companyList/companyList.html'),
            controller: 'ngDroUaaCompanyListCtrl',
            parent: 'main'
        })
        .state('uaa-module-company-add', {
            url: '/company/add',
            template: require('../components/company/companyDetail/companyDetail.html'),
            controller: 'ngDroUaaCompanyDetailCtrl',
            parent: 'main'
        })
        .state('uaa-module-company-edit', {
            url: '/company/:id/edit',
            template: require('../components/company/companyDetail/companyDetail.html'),
            controller: 'ngDroUaaCompanyDetailCtrl',
            parent: 'main'
        })

        .state('uaa-module-audit-list', {
            url: '/audit',
            template: require('../components/audit/auditList/auditList.html'),
            controller: 'ngDroUaaAuditListCtrl',
            parent: 'main'
        })

        .state('uaa-module-template-list', {
            url: '/template',
            template: require('../components/template/templateList/templateList.html'),
            controller: 'ngDroUaaTemplateListCtrl',
            parent: 'main'
        })
        .state('uaa-module-template-add', {
            url: '/template/add',
            template: require('../components/template/templateDetail/templateDetail.html'),
            controller: 'ngDroUaaTemplateDetailCtrl',
            parent: 'main'
        })
        .state('uaa-module-template-edit', {
            url: '/template/:id/edit',
            template: require('../components/template/templateDetail/templateDetail.html'),
            controller: 'ngDroUaaTemplateDetailCtrl',
            parent: 'main'
        })
        .state('handles-403-loop', {
            url: '/403',
            template: require('../components/on403Loop/on403Loop.html'),
            controller: 'ngDroUaaOn403Ctrl',
            parent: 'main'
        })

//        .state('uaa-module-test-role', {
//            url: '/test/role',
//            template: require('../components/test/testRoleREST/testRoleREST.html'),
//            controller: 'ngDroUaaTestRoleRESTCtrl',
//            parent: 'main'
//        })
//        .state('uaa-module-test-profile', {
//            url: '/test/profile',
//            template: require('../components/test/testProfileREST/testProfileREST.html'),
//            controller: 'ngDroUaaTestProfileRESTCtrl',
//            parent: 'main'
//        })
//        .state('uaa-module-test-company', {
//            url: '/test/company',
//            template: require('../components/test/testCompanyREST/testCompanyREST.html'),
//            controller: 'ngDroUaaTestCompanyRESTCtrl',
//            parent: 'main'
//        })
//        .state('uaa-module-test-group', {
//            url: '/test/group',
//            template: require('../components/test/testGroupREST/testGroupREST.html'),
//            controller: 'ngDroUaaTestGroupRESTCtrl',
//            parent: 'main'
//        })
//        .state('uaa-module-test-person', {
//            url: '/test/person',
//            template: require('../components/test/testPersonREST/testPersonREST.html'),
//            controller: 'ngDroUaaTestPersonRESTCtrl',
//            parent: 'main'
//        })
//        .state('uaa-module-test-template', {
//            url: '/test/template',
//            template: require('../components/test/testTemplateREST/testTemplateREST.html'),
//            controller: 'ngDroUaaTestTemplateRESTCtrl',
//            parent: 'main'
//        });
}];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/configs/StateProvider.js
// module id = 353
// module chunks = 0